import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { localizeWithPath } from 'monaco-editor/esm/vs/nls.js';
import { raceCancellation } from 'monaco-editor/esm/vs/base/common/async.js';
import { CancellationTokenSource } from 'monaco-editor/esm/vs/base/common/cancellation.js';
import { ILogService } from 'monaco-editor/esm/vs/platform/log/common/log.js';
import { IProgressService } from 'monaco-editor/esm/vs/platform/progress/common/progress.js';
import { Disposable, toDisposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { insert } from 'monaco-editor/esm/vs/base/common/arrays.js';

let TextFileSaveParticipant = class TextFileSaveParticipant extends Disposable {
    constructor(progressService, logService) {
        super();
        this.progressService = progressService;
        this.logService = logService;
        this.saveParticipants = [];
    }
    addSaveParticipant(participant) {
        const remove = insert(this.saveParticipants, participant);
        return toDisposable(() => remove());
    }
    participate(model, context, token) {
        const cts = ( new CancellationTokenSource(token));
        return this.progressService.withProgress({
            title: ( localizeWithPath(
                'vs/workbench/services/textfile/common/textFileSaveParticipant',
                'saveParticipants',
                "Saving '{0}'",
                model.name
            )),
            location: 15 ,
            cancellable: true,
            delay: model.isDirty() ? 3000 : 5000
        }, async (progress) => {
            model.textEditorModel?.pushStackElement();
            for (const saveParticipant of this.saveParticipants) {
                if (cts.token.isCancellationRequested || !model.textEditorModel ) {
                    break;
                }
                try {
                    const promise = saveParticipant.participate(model, context, progress, cts.token);
                    await raceCancellation(promise, cts.token);
                }
                catch (err) {
                    this.logService.error(err);
                }
            }
            model.textEditorModel?.pushStackElement();
        }, () => {
            cts.cancel();
        }).finally(() => {
            cts.dispose();
        });
    }
    dispose() {
        this.saveParticipants.splice(0, this.saveParticipants.length);
        super.dispose();
    }
};
TextFileSaveParticipant = ( __decorate([
    ( __param(0, IProgressService)),
    ( __param(1, ILogService))
], TextFileSaveParticipant));

export { TextFileSaveParticipant };
